import animateScrollTo from 'animated-scroll-to';

export default class ShopAll extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onClickJumpTo = this.onClickJumpTo.bind(this);

    // privates
    this._node = this;
    this._jump_to_item = this._node.querySelectorAll('.jump-to-item');
    this._products_grid = this._node.querySelectorAll('.products-grid-wrapper');

    // events
    this._jump_to_item.forEach((el) => {
      el.addEventListener('click', this.onClickJumpTo);
    });
  }

  onClickJumpTo(e) {
    let el = e.currentTarget,
        index = el.getAttribute('data-index'),
        target = this._node.querySelector(`.products-grid-wrapper[data-index="${index}"]`);

    if (target) {
      let destination = target.offsetTop - 100;
      if (destination !== window.pageYOffset) {
        animateScrollTo(destination);
      }
    }
  }

  /**
   * Handle unmount.
   */
  disconnectedCallback() {
    this._jump_to_item.forEach((el) => {
      el.removeEventListener('click', this.onClickJumpTo);
    });
  }
}
